// extracted by mini-css-extract-plugin
export default {"item":"AlphaSlider_item__2ab4N","wrapper":"AlphaSlider_wrapper__RPRhT","dots":"AlphaSlider_dots__3Mev7"};